import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import StyledCustomization from './StyledCustomization';
import ClientProvider from './client';
export default createDemo(import.meta.url, StyledCustomization, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/how-to-customize/demos/styled-customization/StyledCustomization.tsx",
    "fileName": "StyledCustomization.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Slider from '@mui/material/Slider';\nimport type { SliderProps } from '@mui/material/Slider';\nimport { alpha, styled } from '@mui/material/styles';\n\nconst SuccessSlider = styled(Slider)<SliderProps>(({ theme }) => ({\n  width: 300,\n  color: theme.palette.success.main,\n  '& .MuiSlider-thumb': {\n    '&:hover, &.Mui-focusVisible': {\n      boxShadow: `0px 0px 0px 8px ${alpha(theme.palette.success.main, 0.16)}`,\n    },\n    '&.Mui-active': {\n      boxShadow: `0px 0px 0px 14px ${alpha(theme.palette.success.main, 0.16)}`,\n    },\n  },\n}));\n\nexport default function StyledCustomization() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <SuccessSlider defaultValue={30} />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 22,
        "focusedLines": 1,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Slider from '@mui/material/Slider';\nimport type { SliderProps } from '@mui/material/Slider';\nimport { alpha, styled } from '@mui/material/styles';\n\nconst SuccessSlider = styled(Slider)<SliderProps>(({ theme }) => ({\n  width: 300,\n  color: theme.palette.success.main,\n  '& .MuiSlider-thumb': {\n    '&:hover, &.Mui-focusVisible': {\n      boxShadow: `0px 0px 0px 8px ${alpha(theme.palette.success.main, 0.16)}`,\n    },\n    '&.Mui-active': {\n      boxShadow: `0px 0px 0px 14px ${alpha(theme.palette.success.main, 0.16)}`,\n    },\n  },\n}));\n\nexport default function StyledCustomization() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <SuccessSlider defaultValue={30} />\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "SuccessSlider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "defaultValue"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "30"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 22,
    "focusedLines": 1,
    "collapsible": true,
    "externals": [
      "@mui/material/Slider",
      "@mui/material/styles"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
